module.exports = __webpack_public_path__ + "static/media/sologoamarela.b3f8dd5e.png";